module.exports = __webpack_public_path__ + "img/annual-report@3x.e7f154f7.webp";